import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostBinding, Input, OnInit } from '@angular/core';
import { filter, switchMap, takeUntil } from 'rxjs';
import { ProductService } from '@spartacus/core';

import { SdSpyTargetDirective } from '@seb/web-design-system/core';

import { BaseFaqComponent } from '../../../components/base/base-faq/base-faq.component';
import { transformHeadlineLevelToTitleLevel } from '../../../mappers';
import { WrapperComponent } from '../../../components/static/core';
import { AbstractComponent } from '../abstract-component.component';
import { FAQComponentInterface, FaqEntry } from '../../../models';
import { ProductScopeEnum } from '../../../enums';

@Component({
  selector: 'wc-faq',
  templateUrl: './faq.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    WrapperComponent,
    BaseFaqComponent,
    SdSpyTargetDirective
  ]
})
export class FAQComponent extends AbstractComponent<FAQComponentInterface> implements OnInit {
  @Input() class = '';

  @HostBinding('class')
  get hostClasses(): string {
    return [this.class, 'wc-component is-cms'].filter(Boolean).join(' ');
  }

  faqs: FaqEntry[];
  titleLevelCategory = 2;

  constructor(
    private productService: ProductService,
    private cdr: ChangeDetectorRef
  ) {
    super();
  }

  override mandatoryFunction = (cmp: FAQComponentInterface): boolean => {
    return !!cmp.product;
  };

  ngOnInit(): void {
    this.component$
      .pipe(
        switchMap((cmp: FAQComponentInterface) => {
          // TODO-EL: inutile ??
          // eslint-disable-next-line @typescript-eslint/no-unused-vars
          const titleLevel = cmp.titleLevelCategory ? transformHeadlineLevelToTitleLevel(cmp.titleLevelCategory) : 2;
          return this.productService.get(cmp.product, ProductScopeEnum.FAQ);
        }),
        filter((product) => product?.faqs?.faqEntries?.length > 0),
        takeUntil(this.destroy$)
      )
      .subscribe((product) => {
        this.faqs = product?.faqs?.faqEntries;

        this.setLoaded();
        this.cdr.markForCheck();
      });
  }
}
